<template>
  <div class="container">
    <Header class="header" data-title="렌탈" @rental="rental" :type="'order'"></Header>
    <!-- content(s) -->
    <div id="content" style="padding-bottom: 72px;">
      <section>
        <div class="resultMsg fail onlyMsg">
          <p class="copy">
            렌탈 진행이 불가합니다.
            <br />
            도움 드리지 못해 죄송합니다.
          </p>
        </div>

        <div class="btnArea sticky">
          <button type="button" class="btn_p" @click="$router.push('/')">
            확인
          </button>
        </div>
      </section>
    </div>
    <!-- content(e) -->
  </div>
</template>

<script>
export default {
  methods: {
    rental: function() {
      this.$router.replace('/');
    },
  },
};
</script>
